// @core/api/endpoints/affiliate/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ActivateCampaign } from './activate_campaign';
import { ActivateOffer } from './activate_offer';
import { ApproveAffiliate } from './approve_affiliate';
import { ApproveConversion } from './approve_conversion';
import { ApprovePayout } from './approve_payout';
import { ChangeAffiliateTier } from './change_affiliate_tier';
import { CreateAffiliate } from './create_affiliate';
import { CreateCampaign } from './create_campaign';
import { CreateCommissionTier } from './create_commission_tier';
import { CreateOffer } from './create_offer';
import { CreatePostback } from './create_postback';
import { CreateReferralLink } from './create_referral_link';
import { DeletePostback } from './delete_postback';
import { GetAffiliate } from './get_affiliate';
import { GetAffiliateStats } from './get_affiliate_stats';
import { GetCampaign } from './get_campaign';
import { GetCommissionTier } from './get_commission_tier';
import { GetConversion } from './get_conversion';
import { GetOffer } from './get_offer';
import { GetOfferStats } from './get_offer_stats';
import { GetPayout } from './get_payout';
import { ListAffiliates } from './list_affiliates';
import { ListCampaigns } from './list_campaigns';
import { ListClicks } from './list_clicks';
import { ListCommissionTiers } from './list_commission_tiers';
import { ListConversions } from './list_conversions';
import { ListOffers } from './list_offers';
import { ListPayouts } from './list_payouts';
import { ListPostbacks } from './list_postbacks';
import { ListReferralLinks } from './list_referral_links';
import { PauseCampaign } from './pause_campaign';
import { PauseOffer } from './pause_offer';
import { ProcessPayout } from './process_payout';
import { RejectConversion } from './reject_conversion';
import { RejectPayout } from './reject_payout';
import { RequestPayout } from './request_payout';
import { SuspendAffiliate } from './suspend_affiliate';
import { TrackClick } from './track_click';
import { TrackConversion } from './track_conversion';
import { UpdateAffiliate } from './update_affiliate';
import { UpdateCampaign } from './update_campaign';
import { UpdateCommissionTier } from './update_commission_tier';
import { UpdateOffer } from './update_offer';
import { UpdatePostback } from './update_postback';

// Re-export individual endpoints
export {
  ActivateCampaign,
  ActivateOffer,
  ApproveAffiliate,
  ApproveConversion,
  ApprovePayout,
  ChangeAffiliateTier,
  CreateAffiliate,
  CreateCampaign,
  CreateCommissionTier,
  CreateOffer,
  CreatePostback,
  CreateReferralLink,
  DeletePostback,
  GetAffiliate,
  GetAffiliateStats,
  GetCampaign,
  GetCommissionTier,
  GetConversion,
  GetOffer,
  GetOfferStats,
  GetPayout,
  ListAffiliates,
  ListCampaigns,
  ListClicks,
  ListCommissionTiers,
  ListConversions,
  ListOffers,
  ListPayouts,
  ListPostbacks,
  ListReferralLinks,
  PauseCampaign,
  PauseOffer,
  ProcessPayout,
  RejectConversion,
  RejectPayout,
  RequestPayout,
  SuspendAffiliate,
  TrackClick,
  TrackConversion,
  UpdateAffiliate,
  UpdateCampaign,
  UpdateCommissionTier,
  UpdateOffer,
  UpdatePostback,
};

// Namespace export for convenient usage
export const affiliateApi = {
  ActivateCampaign,
  ActivateOffer,
  ApproveAffiliate,
  ApproveConversion,
  ApprovePayout,
  ChangeAffiliateTier,
  CreateAffiliate,
  CreateCampaign,
  CreateCommissionTier,
  CreateOffer,
  CreatePostback,
  CreateReferralLink,
  DeletePostback,
  GetAffiliate,
  GetAffiliateStats,
  GetCampaign,
  GetCommissionTier,
  GetConversion,
  GetOffer,
  GetOfferStats,
  GetPayout,
  ListAffiliates,
  ListCampaigns,
  ListClicks,
  ListCommissionTiers,
  ListConversions,
  ListOffers,
  ListPayouts,
  ListPostbacks,
  ListReferralLinks,
  PauseCampaign,
  PauseOffer,
  ProcessPayout,
  RejectConversion,
  RejectPayout,
  RequestPayout,
  SuspendAffiliate,
  TrackClick,
  TrackConversion,
  UpdateAffiliate,
  UpdateCampaign,
  UpdateCommissionTier,
  UpdateOffer,
  UpdatePostback,
};
